import React, { useState, useRef } from 'react';

import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  MenuItem,
  MenuList,
  LinearProgress,
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

// import PaymentForm from './classes/PaymentForm.jsx';
import { loadStripe } from '@stripe/stripe-js';
import firebase from '../../firebase/firebaseConfig';
const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

const options = [
  '$15 - Buy 1 Class Package ',
  '$120 - Buy 10 Classes Package',
  '$200 - Buy 20 Classes Package',
];
const optionsSpanish = [
  '$15 - Comprar un paquete de 1 clase',
  '$120 - Comprar un paquete de 10 clase',
  '$200 - Comprar un paquete de 20 clase',
];

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(
  'pk_live_51IIyIkAh8TtFBZazxis90OXanYeEw4qlPP7T8UX0sxXKMVvcDVZOwdo7N1ZklQLRK1i1G3zxdRaV42jvOuLbd0dn00RIvN3X3r'
);

const AccountClasses = ({ user }) => {
  const [disableBuyButton, setDisableBuyButton] = useState(false);
  const [openPackage, setOpenPackage] = useState(false);
  const anchorRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(1);

  const { classStats } = user;
  const classes = useStyles();

  const handleClosePackage = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpenPackage(false);
  };

  const handleTogglePackage = () => {
    setOpenPackage((prevOpen) => !prevOpen);
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpenPackage(false);
  };

  const [openTestOut, setOpenTestOut] = useState(false);

  const handleClickOpenTestOut = () => {
    setOpenTestOut(true);
  };

  const handleCloseTestOut = () => {
    setOpenTestOut(false);
  };

  const buyClasses = async (e) => {
    console.info(`You clicked ${options[selectedIndex]}`);
    const price = Number(
      user.lang === 'English'
        ? options[selectedIndex].slice(
            1,
            options[selectedIndex].indexOf('-') - 1
          )
        : optionsSpanish[selectedIndex].slice(
            1,
            optionsSpanish[selectedIndex].indexOf('-') - 1
          )
    );

    const name =
      user.lang === 'English'
        ? options[selectedIndex].slice(
            options[selectedIndex].indexOf('Buy') + 4
          )
        : optionsSpanish[selectedIndex].slice(
            optionsSpanish[selectedIndex].indexOf('Buy') + 4
          );

    try {
      //Disable the button element
      setDisableBuyButton(true);
      //Get Stripe.js instance
      const stripe = await stripePromise;

      //Call your backend firebase to create the Checkout Session
      const createStripeCheckout = firebase
        .functions()
        .httpsCallable('createCheckoutSession');
      const response = await createStripeCheckout({
        price,
        package: name,
        userUID: await firebase.auth().currentUser.uid,
        homeURL: window.location.href.replace('account', ''),
        currentClassesRemaining: classStats.classesRemaining,
      });

      const sessionId = response.data.id;

      stripe.redirectToCheckout({ sessionId: sessionId });
      //setDisableBuyButton(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleTestOut = async (dance) => {
    //Close  dialog box
    handleCloseTestOut();
    //Call firebase function
    try {
      const sendTwilioSms = firebase.functions().httpsCallable('sendTwilioSms');

      const response = await sendTwilioSms({
        name: user.name,
        dance,
      });
    } catch (error) {
      console.log('There was an error', error);
    }

    //Alert user with the status of their request
  };

  return (
    <div className={classes.content}>
      <h1>
        {user.lang === 'English'
          ? 'Classes Information'
          : 'Información de Clases'}
      </h1>
      <Divider style={{ width: '100%' }} variant='middle' />
      <h2>
        {user.lang === 'English'
          ? 'Purchase More Classes'
          : 'Comprar más clases'}
      </h2>
      {disableBuyButton && (
        <LinearProgress style={{ width: '75%', margin: '5px' }} />
      )}
      <ButtonGroup
        variant='contained'
        color='primary'
        ref={anchorRef}
        aria-label='split button'
        disabled={disableBuyButton}
      >
        <Button onClick={buyClasses}>
          {user.lang === 'English'
            ? options[selectedIndex]
            : optionsSpanish[selectedIndex]}
        </Button>
        <Button
          color='primary'
          size='small'
          aria-controls={openPackage ? 'split-button-menu' : undefined}
          aria-expanded={openPackage ? 'true' : undefined}
          aria-label='select merge strategy'
          aria-haspopup='menu'
          onClick={handleTogglePackage}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper
        open={openPackage}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClosePackage}>
                <MenuList id='split-button-menu'>
                  {user.lang === 'English' &&
                    options.map((option, index) => (
                      <MenuItem
                        key={option}
                        // disabled={index === 2}
                        selected={index === selectedIndex}
                        onClick={(event) => handleMenuItemClick(event, index)}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  {user.lang === 'Spanish' &&
                    optionsSpanish.map((option, index) => (
                      <MenuItem
                        key={option}
                        // disabled={index === 2}
                        selected={index === selectedIndex}
                        onClick={(event) => handleMenuItemClick(event, index)}
                      >
                        {option}
                      </MenuItem>
                    ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
      {/* <p>Certificate</p> */}
      <h3>{user.lang === 'English' ? 'Statistics' : 'Estadísticas'}</h3>
      <p>
        {user.lang === 'English'
          ? 'Classes Remaining: '
          : 'Las Clases Restantes: '}
        {classStats.classesRemaining}
      </p>
      <p>
        {' '}
        {user.lang === 'English'
          ? 'Classes Taken: '
          : 'Las Clases Tomadas: '}{' '}
        {classStats.classesTaken}
      </p>
      <br />
      <h3>
        {user.lang === 'English'
          ? 'Want to advance to another level?'
          : 'Quieres tomar la prueba para avanzar a otro nivel?'}{' '}
      </h3>
      <Button
        onClick={handleClickOpenTestOut}
        variant='contained'
        color='secondary'
      >
        {' '}
        {user.lang === 'English' ? 'Test Out!' : 'Tomar La Prueba!'}
      </Button>
      <Dialog
        open={openTestOut}
        onClose={handleCloseTestOut}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        disable
      >
        <DialogTitle id='alert-dialog-title'>
          {'Test to Another Dance Level?'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Are you ready to take a test to advance to another dance level in
            Salsa/Bachata? Note: This will send a message to one of our
            instructors.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => handleTestOut('salsa')}
            variant='contained'
            color='primary'
          >
            Salsa
          </Button>
          <Button
            onClick={(e) => handleTestOut('bachata')}
            variant='contained'
            color='secondary'
          >
            Bachata
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AccountClasses;
